import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import StandardApiError from "shared/errors/standardApiError";
import { getParsedStandardApiErrors } from "shared/errors/errorHandling";

export const mutateSignOut = async () => {
  try {
    const response = await makeMutation(ApiEndpoints.signOut(), null, true);
    return { success: response.success };
  } catch (error) {
    if (!(error instanceof StandardApiError)) {
      throw error;
    }
    const parsedErrors = getParsedStandardApiErrors(error);
    const errorCodes = parsedErrors?.errors.map((item) => item.errorCode);
    if (errorCodes?.includes('INVALID_TOKEN')) {
      return
    }

    throw error;
  }
};
